<script setup lang="ts">
import { useCostStore } from '@/stores/cost'
import { storeToRefs } from 'pinia'
import { ChoiceField, HelpTextTooltip, TextField } from '@haskoning/vue-component-library'

const costStore = useCostStore()
const { currentItem: currentCostItem } = storeToRefs(costStore)

const costFields = [
  'currency',
  'rock_armour',
  'rock_filter_layer',
  'gabion',
  'concrete_block',
  'insitu_filled_mattress_proserve',
  'blockmat',
  'asphaltmatt',
  'filter_net',
  'geotextile'
]

const hasHelpText = (field: string) => {
  return !!costStore.fields[field]?.help_text
}
</script>

<template>
  <v-card v-if="costStore.fields" elevation="0" flat>
    <v-card-title class="header-font"> Cost unit rates</v-card-title>
    <v-card-subtitle class="description-font mb-6">
      Please select your cost unit rates. These will be used for all calculations in your project.
    </v-card-subtitle>

    <v-card-text>
      <v-row align="center" no-gutters v-for="field in costFields" :key="field">
        <v-col cols="12" md="8" lg="4" class="d-flex align-center">
          <HelpTextTooltip
            v-if="hasHelpText(field)"
            :text="costStore.fields[field].help_text || ''"
          />
          <span :class="hasHelpText(field) ? 'px-2' : 'px-0'">
            {{ costStore.fields[field].label }}
          </span>
        </v-col>

        <v-col cols="12" md="8" lg="4" class="pt-0">
          <ChoiceField
            v-if="costStore.fields[field].type === 'choice'"
            :field="costStore.fields[field]"
            :model-value="currentCostItem"
            :no-help-text="true"
            :readonly="!costStore.canChangeCost"
            @update="costStore.update(currentCostItem)"
          />
          <TextField
            v-else
            :field="costStore.fields[field]"
            :model-value="currentCostItem"
            :no-help-text="true"
            :readonly="!costStore.canChangeCost"
            @update="costStore.update(currentCostItem)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
